var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.266 14.297l-.909-5.034 3.416-3.024-4.633-.315-2.153-4.743-2.332 4.85-4.371.224L5.076 9.48l-1.244 4.764 4.17-2.28 4.264 2.334z",
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.1' width='16px' height='16px' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-647 -865)' stroke='%23000'%3E %3Cg transform='translate(647 865)'%3E %3Cpath d='m12.266 14.297l-0.90882-5.0342 3.4161-3.0243-4.6333-0.31434-2.1533-4.7431-2.3321 4.8503-4.371 0.22401 3.7929 3.2232-1.2444 4.7647 4.1691-2.2809 4.2649 2.3345z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgStar as ReactComponent };